import { render } from "./Error404.vue?vue&type=template&id=b183e880"
const script = {}

import exportComponent from "C:\\Users\\jarre\\OneDrive\\Desktop\\MSD\\msd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__